<div class="sectionWrapper">
  <div class="leaderSection">
    <div class="headerTitle">
      <h1 class="leaderH1">
        The <span class="cscGoldText">Leader</span> in Crowd Management
      </h1>
      <h2>
        Let's be part of this
        <span class="cscGoldText">experience</span> together.
      </h2>
    </div>
    <div class="safetyActCertifiedImg">
      <img
      loading="lazy"
        class=""
        src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2FmiscImages%2Fsafety_act_certification_200w.png?alt=media&token=62f9f499-f8e0-407c-8c1e-1e7f9e5f0619"
        alt="safety act certification"
      />
    </div>
    <div class="safetyActDesignatedImg">
      <img
      loading="lazy"
        class=""
        src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2FmiscImages%2FCSC_ESOP.gif?alt=media&token=6f0b754c-8a15-45c1-a680-9569e120a3b2"
        alt="An employee owned company"
      />
    </div>
    <div class="cscIntro">
      <p class="">
        {{ headerCopy }}
      </p>
    </div>
  </div>
</div>
